import { PILL_KEY } from 'src/app/shared/models/attributes/attributeConstants';

export class Tag {
  public id: string;
  public text: string;
  public color?: PILL_KEY;
  public workspaceId: string;
  public type: TagType;

  constructor(tag: Partial<Tag> = undefined) {
    if (tag) {
      this.id = tag.id;
      this.text = tag.text;
      this.color = tag.color;
      this.workspaceId = tag.workspaceId;
      this.type = tag.type;
      // Handling for creating a new tag
      if (this.id === this.text) {
        this.id = undefined;
      }
    }
  }

  public isSameTag(tagText: string) {
    return this.text === tagText;
  }
}

export enum TagType {
  Person = 'Person',
  PersonCredentialScenario = 'PersonCredentialScenario',
  TeamCredentialScenario = 'TeamCredentialScenario'
}
